import { connect } from "react-redux";
import AvatarPasswordSidebar from "../components/sidebars/AvatarPasswordSidebar";
import PasswordSidebar from "../components/sidebars/PasswordSidebar";
import SettingSidebar from "../components/sidebars/SettingSidebar";
import TermsCheckSidebar from "../components/sidebars/TermsCheckSidebar";
import TermsSidebar from "../components/sidebars/TermsSidebar";
import UnlinkPasswordSidebar from "../components/sidebars/UnlinkPasswordSidebar";

const DefaultLayout = ({ children }) => {

  return <>
    <div
      className="height-fill-mobile"
      style={{
        width: "100vw",
        height: "100vh",
      }}
    >
      {children}
    </div>
    <TermsSidebar />
    <TermsCheckSidebar />
    <SettingSidebar />
    <PasswordSidebar />
    <AvatarPasswordSidebar />
    <UnlinkPasswordSidebar />
  </>
};

const mapState = (state) => {
  return {};
};

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(DefaultLayout);
